// 漫画软件应用指南 - 站内内容数据
// 该文件集中管理单页站各区块的展示数据

export const brandName = "漫读指南";

export const navItems = [
  { id: "features", label: "功能总览" },
  { id: "reading", label: "阅读模式" },
  { id: "night", label: "夜间模式" },
  { id: "offline", label: "离线缓存" },
  { id: "subscribe", label: "订阅提醒" },
  { id: "search", label: "分类检索" },
  { id: "faq", label: "常见问题" },
];

export interface FeatureItem {
  icon: string;
  title: string;
  desc: string;
}

export const featureItems: FeatureItem[] = [
  {
    icon: "ri-book-open-line",
    title: "阅读模式",
    desc: "翻页、滚动、分镜三种阅读方式自由切换，单双页与阅读方向随你调整，找到最舒服的追漫姿势。",
  },
  {
    icon: "ri-moon-clear-line",
    title: "夜间模式",
    desc: "深色护眼配色配合定时开启，深夜追漫不再刺眼，亮度与对比度还能单独微调。",
  },
  {
    icon: "ri-download-2-line",
    title: "缓存下载",
    desc: "整本或单话一键缓存到本地，缓存管理一目了然，空间占用清晰可见，智能清理更省心。",
  },
  {
    icon: "ri-notification-3-line",
    title: "订阅提醒",
    desc: "追更列表集中管理，新章节更新第一时间推送，不错过任何一次人气新作连载。",
  },
  {
    icon: "ri-grid-fill",
    title: "分类检索",
    desc: "热血、恋爱、悬疑、搞笑等分类一目了然，关键词、标签与排序结合，快速找到想看的作品。",
  },
  {
    icon: "ri-cloud-off-line",
    title: "离线阅读",
    desc: "没有网络也能畅快看漫，已缓存内容无缝续读，地铁、飞行途中照样追更不断。",
  },
];

export interface ReadingMode {
  icon: string;
  title: string;
  desc: string;
}

export const readingModes: ReadingMode[] = [
  {
    icon: "ri-book-2-line",
    title: "翻页模式",
    desc: "模拟实体漫画翻页体验，点击或左右滑动即可翻页，配合页面加载预读取，翻页丝滑不卡顿。",
  },
  {
    icon: "ri-scroll-to-bottom-line",
    title: "滚动模式",
    desc: "长图竖屏连续滚动，无需频繁点击，适合手机竖屏单手操作，阅读节奏自由掌控。",
  },
  {
    icon: "ri-crop-2-line",
    title: "分镜模式",
    desc: "智能识别对话与分镜，逐格放大跟随，对话气泡、细节特写清晰呈现，沉浸感更强。",
  },
];

export const readingTips = [
  "单页 / 双页切换",
  "左右 / 上下阅读方向",
  "页面预加载与翻页缓冲",
  "书签与阅读进度记忆",
];

export const nightModes = [
  { title: "定时自动开启", desc: "设定每天日落或固定时间，夜间模式自动切换，无需手动操作。" },
  { title: "深色护眼配色", desc: "针对漫画阅读优化的低亮度色阶，减少眩光，长时间看漫更舒适。" },
  { title: "亮度单独微调", desc: "夜间模式下可独立调整画面亮度与对比度，兼顾画面细节与护眼。" },
  { title: "跟随系统切换", desc: "一键跟随系统深色模式，白天黑夜自动同步，体验更统一。" },
];

export const offlineSteps = [
  { title: "选择缓存范围", desc: "支持单话缓存或整部作品批量缓存，勾选你近期想看的章节即可。" },
  { title: "管理缓存内容", desc: "在缓存中心查看已下载作品，按作品、话数整理，一键续读不迷路。" },
  { title: "智能清理空间", desc: "已读完或长期不看的缓存可快速清理，剩余空间实时显示，心里有数。" },
  { title: "断网无缝续读", desc: "没有网络时自动读取本地缓存，阅读进度与在线端同步保留。" },
];

export const subscribeSteps = [
  { title: "加入追更列表", desc: "看到感兴趣的作品一键订阅，追更列表集中展示，随时掌握更新动态。" },
  { title: "新章实时提醒", desc: "作品更新后第一时间推送提醒，配合铃声或震动，不错过人气新作连载。" },
  { title: "更新日历总览", desc: "按星期查看更新日历，提前规划追更节奏，忙也不怕漏看。" },
  { title: "免打扰模式", desc: "夜深或开会时可临时静音提醒，想看时再看，更新记录也不会丢失。" },
];

export const searchCategories = [
  "热血", "恋爱", "悬疑", "搞笑", "奇幻", "科幻", "校园", "运动",
];

export const searchFilters = [
  { icon: "ri-search-line", title: "关键词搜索", desc: "输入作品名、作者或角色名，快速定位目标漫画。" },
  { icon: "ri-price-tag-3-line", title: "标签筛选", desc: "叠加风格、题材、连载状态等标签，缩小检索范围。" },
  { icon: "ri-history-line", title: "浏览历史", desc: "自动记录最近浏览，一键回到上次看到的地方。" },
  { icon: "ri-sort-asc", title: "智能排序", desc: "按更新、人气、评分等维度排序，热门作品尽在眼前。" },
];

export interface FaqItem {
  q: string;
  a: string;
}

export const faqItems: FaqItem[] = [
  {
    q: "缓存到本地会占用多少空间？",
    a: "占用空间与作品画质、篇幅直接相关。单话缓存通常在几十 MB 左右，整部作品则视篇幅而定。你可以在缓存管理页实时查看每部作品的大小，已读内容也可一键清理，避免占用过多手机存储。",
  },
  {
    q: "夜间模式能定时自动开启吗？",
    a: "可以。夜间模式支持设定固定时间段或跟随系统深色模式自动切换，无需每天手动操作。开启后还会进入专为漫画阅读优化的低亮度配色，亮度与对比度可单独微调，深夜看漫更护眼。",
  },
  {
    q: "订阅提醒会不会消耗很多流量？",
    a: "订阅提醒的推送消息非常轻量，只在作品更新时发送一条提示，不会频繁消耗流量。如果你开启免打扰模式，通知会被暂存，更新记录不会丢失，查看时依然完整。",
  },
  {
    q: "离线缓存的内容会过期吗？",
    a: "已经成功缓存到本地的内容可随时离线阅读，不受网络影响。个别需要在线授权或长期未更新的作品，联网后可能会提示刷新以获取最新版本，其余已缓存章节通常不会过期。",
  },
  {
    q: "分类检索可以自定义标签吗？",
    a: "除了官方分类，多数漫画软件应用支持按标签、题材与连载状态组合筛选。部分应用还允许收藏自定义书单或标签，方便你把喜欢的作品归整到一起。",
  },
  {
    q: "切换阅读模式后阅读进度会保留吗？",
    a: "会保留。翻页、滚动、分镜等阅读模式的切换不会影响阅读进度，书签与最近阅读位置都会自动记忆，随时切换、随时续读。",
  },
];

export const aboutPoints = [
  "以真实使用体验为准，功能说明通俗易懂",
  "聚焦阅读模式、缓存、订阅等实用技巧",
  "内容持续更新，紧跟主流漫画软件应用变化",
  "坚持客观中立，不做盲目堆砌的营销宣传",
];

export const contactInfo = {
  email: "hello@manduzhinan.example.com",
  note: "有关漫画软件应用的使用问题，欢迎来信交流。",
};